// 主要輪盤
import { SPIN_COLORS } from '@/common/constant'; // 輪盤顏色

// 扇形
const CircleSlice = ({ index, color, radius, prize }) => {
    const angle = (360 / 17) * index;
    const nextAngle = (360 / 17) * (index + 1);
    const largeArcFlag = nextAngle - angle > 180 ? 1 : 0;

    const d = `
      M 0 0 
      L ${radius * Math.cos((angle * Math.PI) / 180)} ${radius * Math.sin((angle * Math.PI) / 180)} 
      A ${radius} ${radius} 0 ${largeArcFlag} 1 ${radius * Math.cos((nextAngle * Math.PI) / 180)} ${
        radius * Math.sin((nextAngle * Math.PI) / 180)
    } 
      Z
    `;

    // 計算文字的角度和位置
    const textAngle = (angle + nextAngle) / 2;
    const textX = (radius - 9) * Math.cos((textAngle * Math.PI) / 180); // 與圓心距離
    const textY = (radius - 9) * Math.sin((textAngle * Math.PI) / 180);

    return (
        <g>
            <path
                d={d}
                fill={color}
                stroke="rgba(255,255,255,.3)" // 邊框顏色
                strokeWidth=".2" // 邊框厚度
            />

            {/* 輪盤抽獎券圖片 */}
            <image
                href={prize?.image} // 圖片路徑
                x={textX - 5.5} // 調整圖片位置
                y={textY - 16} // 調整圖片位置
                transform={`rotate(${textAngle - 90}, ${textX}, ${textY})`} // 旋轉文字
                height="11" // 調整圖片大小
                width="11" // 調整圖片大小
            />

            {/* 抽獎券數量 */}
            <text
                x={textX}
                y={textY}
                fill="white"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight={300} // 文字粗細
                fontSize="5" // 文字大小
                transform={`rotate(${textAngle - 90}, ${textX}, ${textY})`} // 旋轉文字
            >
                {prize?.amount || 1}
            </text>
            {prize?.type === 'bonus' && (
                <text
                    x={textX}
                    y={textY - 20}
                    fill="white"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontWeight={300} // 文字粗細
                    fontSize="3.5" // 文字大小
                    transform={`rotate(${textAngle - 90}, ${textX}, ${textY})`} // 旋轉文字
                >
                    Bonus
                </text>
            )}
        </g>
    );
};

const CampaignRouletteComponent = ({ roulettes, rotateAngle, handleStopSpin }) => {
    return (
        <div
            className="spin absolute z-[2] w-full h-full center-center"
            style={{ transform: `rotate(${rotateAngle}deg)` }}
            // 判斷旋轉結束後
            onTransitionEnd={() => setTimeout(() => handleStopSpin(), 300)}
        >
            <svg width="100%" height="100%" viewBox="0 0 168 168">
                <g transform="translate(84, 84)">
                    {/* 17 塊扇形 組成 圓形 */}
                    {roulettes?.map((v, index) => (
                        <CircleSlice
                            key={index}
                            index={index}
                            color={SPIN_COLORS[index % SPIN_COLORS.length]}
                            radius={80}
                            prize={v}
                        />
                    ))}
                </g>
            </svg>
        </div>
    );
};

export default CampaignRouletteComponent;
